import {KeyPerson} from 'api';
import React from 'react';
import SnsComponent from './Sns';
import Menu from './Menu';
import Media from './Media';
import Name from './Name';
import Department from './Department';
import Position from './Position';
import TelephoneNumber from './TelephoneNumber';
import Note from './Note';

interface KeyPersonDetailParams {
  id: string;
  keyPerson: KeyPerson;
  fullName: string;
  department: string;
  position: string;
  facebookUrl: string;
  linkedinUrl: string;
  xUrl: string;
  wantedlyUrl: string;
  eightUrl: string;
  telephoneNumber: string;
  note: string;
}

interface Props {
  params: KeyPersonDetailParams;
  preleadUuid: string;
}

export default ({params, preleadUuid}: Props) => {
  const {
    id,
    keyPerson,
    fullName,
    department,
    position,
    facebookUrl,
    linkedinUrl,
    xUrl,
    wantedlyUrl,
    eightUrl,
    telephoneNumber,
    note,
  } = params;
  return (
    <div key={id} className="border-b border-c-border p-4">
      <div className="flex w-full items-center">
        <Name fullName={fullName} />
        <SnsComponent
          facebookUrl={facebookUrl}
          linkedinUrl={linkedinUrl}
          xUrl={xUrl}
          wantedlyUrl={wantedlyUrl}
          eightUrl={eightUrl}
        />
        <Menu keyPerson={keyPerson} preleadUuid={preleadUuid} />
      </div>
      <Department department={department} />
      <Position position={position} />
      <Media keyPerson={keyPerson} />
      <TelephoneNumber telephoneNumber={telephoneNumber} />
      <Note note={note} />
    </div>
  );
};
